import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: number = 0;

export const getContragentSlice = createSlice({
 name: 'getContragent',
 initialState,
 reducers: {
  getContragent: (state, action: PayloadAction<number>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { getContragent } = getContragentSlice.actions;

export default getContragentSlice.reducer;
